import {Fetch} from "helpers/fetchWrapper";

const notificationService = {
    _baseUrl: process.env.REACT_APP_NOTIFICATION_URL || "http://localhost:4006/api/v1/notification",

    /**
     * Get all notifications
     */
    async getAllNotifications(recipientId, page = 1, itemsPerPage = 10) {
        try {
            const url = `${this._baseUrl}/getAll?recipientId=${recipientId}&page=${page}&itemsPerPage=${itemsPerPage}`;
            const res = await Fetch.get(url);

            if (res.status >= 200 && res.status < 300) {
                const data = await res.json();
                return data;
            }

            const errorData = await res.json();
            throw new Error(errorData.message || "Failed to fetch notifications");
        } catch (error) {
            console.error("❌ [NotificationService] Error fetching notifications:", error);
            throw error;
        }
    },

    /**
     * Mark notification as read
     */
    async markAsRead(id) {
        try {
            const url = `${this._baseUrl}/read-notification/${id}`;
            const res = await Fetch.patch(url, {});

            if (res.status >= 200 && res.status < 300) {
                const data = await res.json();
                return data;
            }

            const errorData = await res.json();
            throw new Error(errorData.message || "Failed to mark as read");
        } catch (error) {
            console.error("❌ [NotificationService] Error marking as read:", error);
            throw error;
        }
    },

    /**
     * Mark all notifications as read
     */
    async markAllAsRead(recipientId) {
        try {
            const url = `${this._baseUrl}/mark-all-read`;
            const res = await Fetch.post(url, { recipientId });

            if (res.status >= 200 && res.status < 300) {
                const data = await res.json();
                console.log("✅ [NotificationService] All marked as read:", data);
                return data;
            }

            const errorData = await res.json();
            throw new Error(errorData.message || "Failed to mark all as read");
        } catch (error) {
            console.error("❌ [NotificationService] Error marking all as read:", error);
            throw error;
        }
    },

    /**
     * Delete notification
     */
    async deleteNotification(id) {
        try {
            const url = `${this._baseUrl}/${id}`;
            const res = await Fetch.delete(url);

            if (res.status >= 200 && res.status < 300) {
                const data = await res.json();
                return data;
            }

            const errorData = await res.json();
            throw new Error(errorData.message || "Failed to delete notification");
        } catch (error) {
            console.error("❌ [NotificationService] Error deleting notification:", error);
            throw error;
        }
    },

    /**
     * Get notification statistics
     */
    async getStats(recipientId) {
        try {
            const url = `${this._baseUrl}/stats?recipientId=${recipientId}`;
            const res = await Fetch.get(url);

            if (res.status >= 200 && res.status < 300) {
                const data = await res.json();
                console.log("✅ [NotificationService] Stats fetched:", data);
                return data;
            }

            const errorData = await res.json();
            throw new Error(errorData.message || "Failed to fetch stats");
        } catch (error) {
            console.error("❌ [NotificationService] Error fetching stats:", error);
            throw error;
        }
    },
};

export default notificationService;
